import { render, staticRenderFns } from "./ChatProgram.vue?vue&type=template&id=484c55e8&"
import script from "./ChatProgram.vue?vue&type=script&lang=js&"
export * from "./ChatProgram.vue?vue&type=script&lang=js&"
import style0 from "./ChatProgram.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports